import"../../../node_modules/.pnpm/@lit_reactive-element@2.1.0/node_modules/@lit/reactive-element/reactive-element.js";import{html as t}from"../../../node_modules/.pnpm/lit-html@3.3.0/node_modules/lit-html/lit-html.js";import"../../../node_modules/.pnpm/lit-element@4.2.0/node_modules/lit-element/lit-element.js";import{icon as C}from"../../icon-registry.js";const h=C("bolt",t`
        <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg">
            <path
                d="M10.6539 18.2082L15.8707 11.9581H11.8384L12.5692 6.23724L7.90686 12.9662H11.4099L10.6539 18.2082ZM9.09136 14.9824H5.9663C5.56306 14.9824 5.26484 14.8017 5.07162 14.4405C4.87841 14.0793 4.89941 13.7307 5.13463 13.3946L12.6701 2.55773C12.8381 2.32251 13.0565 2.1587 13.3253 2.06629C13.5941 1.97388 13.8714 1.97809 14.157 2.07889C14.4426 2.1797 14.6526 2.35612 14.787 2.60814C14.9214 2.86016 14.9718 3.12898 14.9382 3.4146L14.1318 9.94195H18.0381C18.4749 9.94195 18.7816 10.1352 18.958 10.5216C19.1344 10.908 19.0798 11.2693 18.7942 11.6053L10.5027 21.5349C10.3179 21.7533 10.091 21.8961 9.82222 21.9633C9.55339 22.0305 9.29297 22.0053 9.04095 21.8877C8.78893 21.7701 8.59151 21.5895 8.4487 21.3459C8.30589 21.1023 8.25129 20.8376 8.28489 20.552L9.09136 14.9824Z"
                fill="#FCFCFC" />
        </svg>
    `),e=C("bolt_filled",t`
        <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg">
            <mask
                id="mask0_18095_54609"
                style="mask-type:alpha"
                maskUnits="userSpaceOnUse"
                x="0"
                y="0"
                width="24"
                height="24">
                <rect
                    width="24"
                    height="24"
                    fill="#D9D9D9" />
            </mask>
            <g mask="url(#mask0_18095_54609)">
                <path
                    d="M9.15044 14.9824H6.02538C5.62215 14.9824 5.32392 14.8017 5.1307 14.4405C4.93749 14.0793 4.95849 13.7307 5.19371 13.3946L12.7291 2.55773C12.8971 2.32251 13.1156 2.1587 13.3844 2.06629C13.6532 1.97388 13.9304 1.97809 14.2161 2.07889C14.5017 2.1797 14.7117 2.35612 14.8461 2.60814C14.9805 2.86016 15.0309 3.12898 14.9973 3.4146L14.1909 9.94195H18.0972C18.534 9.94195 18.8406 10.1352 19.0171 10.5216C19.1935 10.908 19.1389 11.2693 18.8532 11.6053L10.5618 21.5349C10.3769 21.7533 10.1501 21.8961 9.8813 21.9633C9.61248 22.0305 9.35206 22.0053 9.10003 21.8877C8.84801 21.7701 8.6506 21.5895 8.50779 21.3459C8.36497 21.1023 8.31037 20.8376 8.34397 20.552L9.15044 14.9824Z"
                    fill="#FCFCFC" />
            </g>
        </svg>
    `);export{h as Bolt,e as BoltFilled};
